import React, { Component } from 'react'
import Dialog from 'react-bootstrap-dialog'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Loader from 'react-loader-advanced'
import * as Constants from '../../../../common/constants'
import { employeesTableReady } from '../../redux/employees'
import { buildNumberUpdate, } from '../../../../redux/user'
import apiService from '../../services/apiservices'



//import * as Helpers from '../../../../common/helpers'


class PermanentEmployeeModalLayout extends Component {
    constructor() {
        super()
        this.state = {
            oldEmployee: {},
            isUpdating: false,
            employee_code: '',

            employee_codeErrorText: false,
            employee_codeErrorData: '',

        }
        this.dialog = null

        this.isComponentStillMount = true

        this.employee_codeComponent = null
        this.employee_codeSection = null

        this.reasonIdComponent = null
        this.reasonIdSection = null
    }

    componentWillMount() {
        this.isComponentStillMount = true

        // if(this.props.data && this.props.data.id){
        //     this.props.dispatch(employeesTableReady(false))
        //     this.getEmployeeById(this.props.data.id)
        // }


    }

    componentDidMount() {

    }


getEmployeeById = (id) => {
     apiService.getEmployeeById(id)
            .then(responseData => {                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(employeesTableReady(true))
                        this.setState({
                            oldEmployee: responseData.data
                        });
                    } else {

                        this.props.dispatch(employeesTableReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(employeesTableReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })

    }


mandateValidation = (inputName, type) => {
    let inputComponent = inputName + "Component"
    let inputErrorText = inputName + "ErrorText"
    let inputErrorData = inputName + "ErrorData"
    let inputSection = inputName + "Section"
    let errorMsg = Constants.NON_VALID_MSG_INPUT
    if (Constants.FORM_SELECT === type) {
        errorMsg = Constants.NON_VALID_MSG_SELECT
        console.log("input name :::", inputName)
        console.log("input data :::", this.state[inputName])
    }
    if (this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === "") {
        this[inputComponent].focus()
        this.setState({
            [inputErrorText]: true,
            [inputErrorData]: errorMsg
        })
        this[inputSection].className = this[inputSection].className.replace(" has-error", "")
        this[inputSection].className += " has-error"
        return {
            status: false,
            value: ''
        }
    }
    return {
        status: true
    }
}

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    componentWillUnmount() {
        this.isComponentStillMount = false
    }







    

    handleOnSubmit = (e) => {

        e.preventDefault();

        this.props.dispatch(employeesTableReady(false))
        let data = {}


        let employee_codeObject = this.mandateValidation("employee_code", Constants.FORM_INPUT)
        if (employee_codeObject.status) {
            data.employee_code=this.employee_codeComponent.value         

        } else {
            this.props.dispatch(employeesTableReady(true))
            return
        }


    let apiPayloadData=data;


    apiService.editEmployeeMovement(apiPayloadData,this.props.data.id)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(employeesTableReady(true))
                        this.props.closeModal(false)
                        window.location.reload()
                    } else {

                        this.props.dispatch(employeesTableReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(employeesTableReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })




}



  
    render() {

        return (
            <div className="qr-code-reader-modal">
                <Dialog ref={el => this.dialog = el} />
                <Loader
                    show={this.state.isUpdating}
                    message={'Updating...Please wait'}
                    foregroundStyle={{ color: "#ffffff", fontSize: "17px", fontWeight: "600" }}>
                    <div className="modal-header">
                        <button type="button" className="close"
                            onClick={(e) => {
                                e.preventDefault()
                                this.props.closeModal(false)
                            }}>
                            <span>&times;</span></button>
                        <h4 className="modal-title">Make This Employee Permanent [ Name : {this.props.data.name} ]</h4>
                    </div>

                    <div className="modal-body">
                            <div className="form-horizontal">


                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-11 col-sm-12 col-xs-12">
                                            <div className="form-group" ref={el => this.employee_codeSection = el}>
                                                    <label className="col-sm-6 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Permanent Employee Code *</label>
                                                    <div className="col-sm-6">
                                                        <input className="form-control" placeholder="Enter Employee Code" type="number" ref={el => this.employee_codeComponent = el}
                                                              onChange={(e) => {e.preventDefault() 
                                                              this.keyedInputChange("employee_code")}} />
                                                        <span className="help-block"style={{display: this.state.employee_codeErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.employee_codeErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>


                            </div>
                    </div>
                    <div className="modal-footer" style={{marginTop: "13%"}}>
                        <button type="button" className="btn btn-primary pull-left"
                            onClick={(e) => {
                                e.preventDefault()
                                this.props.closeModal(false)
                            }}>Close</button>
                            <button
                                    className="btn btn-info pull-right"
                                    style={{ width: "auto" }}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        this.handleOnSubmit(e);
                                    }} >
                                    Submit
                                </button>
                    </div>

            </Loader>
            </div>
        )
    }


    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        employees: state.employees,
    }
}

export default connect(mapStateToProps)(withRouter(PermanentEmployeeModalLayout))


// WEBPACK FOOTER //
// ./src/modules/Employees/Components/EmployeeModalLayout/PermanentEmployeeModalLayout.js